import React, { useEffect } from "react";
import { Container } from "reactstrap";
import withRouter from 'components/Common/withRouter';
import { useLayout } from "../../hooks/useLayout";

// Layout Related Components
import Header from "./Header";
import Sidebar from "./Sidebar";

const Layout = (props) => {
  const { sidebarOpen, toggleSidebar } = useLayout();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  useEffect(() => {
      // Aplicar classes no body dependendo do estado do sidebar
      if (sidebarOpen) {
          document.body.classList.add("sidebar-enable");
          if (!isMobile) {
              document.body.classList.remove("vertical-collpsed");
          }
      } else {
          document.body.classList.remove("sidebar-enable");
          if (!isMobile) {
              document.body.classList.add("vertical-collpsed");
          }
      }
  }, [sidebarOpen, isMobile]);

  return (
    <React.Fragment>
      <div id="layout-wrapper">
        <Header toggleMenuCallback={toggleSidebar} />
        <Sidebar
          theme="dark"
          type={sidebarOpen ? "default" : "condensed"}
          isMobile={isMobile}
        />
        <div className="main-content">
          <div className="page-content">
            <Container fluid>
              {props.children}
            </Container>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Layout);
